<template>
  <div id="app">
    <div class="content">
    <!-- <b-navbar id="menu-top" toggleable="lg"  fixed> 
      <img
        id="navigation-bar-logo"
        src="https://www.opensalud.es/Content/img/home/logo-blue.svg"
        alt="opensalud"
      />
      <b-nav-text style="margin-left: 10px;">
        {{ $t("menu-label-patient") }}
        <b>{{ this.$store.getters.getPatientName }}</b>
      </b-nav-text>
        <b-navbar-nav class="ml-auto">
          <b-nav-item>
              <img src="/static-appopensalud/img/icons/phone-slash-red.svg" /> {{ $t('menu-end-session') }}
          </b-nav-item>
        </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item>
              <img src="/static-appopensalud/img/icons/comments-gray.svg" /> {{ $t('menu-chat') }}
          </b-nav-item>
            <b-nav-item-dropdown  :text="$t('menu-audio')" image="/static-appopensalud/img/icons/microphone-gray.svg">
              <b-dropdown-item @click='muteVideo()' href="#"><img src="/static-appopensalud/img/icons/microphone-slash-gray.svg"> {{ $t('menu-mute-audio') }}</b-dropdown-item>
            </b-nav-item-dropdown >
          <b-nav-item-dropdown  :text="$t('menu-video')">
              <b-dropdown-item @click='muteVideo()' href="#"><img src="/static-appopensalud/img/icons/webcam-slash-gray.svg"> {{ $t('menu-mute-video') }}</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <h6 class="dropdown-header">{{ $t('menu-title-video-quality') }}</h6>
              <b-dropdown-item @click='setVideoQualityHigh()' href="#"><img src="/static-appopensalud/img/icons/tachometer-alt-fastest-gray.svg"> {{ $t('menu-video-quality-high') }}</b-dropdown-item>
              <b-dropdown-item @click='setVideoQualityMedium()' href="#"><img src="/static-appopensalud/img/icons/tachometer-alt-average-gray.svg"> {{ $t('menu-video-quality-medium') }}</b-dropdown-item>
              <b-dropdown-item @click='setVideoQualityLow()' href="#"><img src="/static-appopensalud/img/icons/tachometer-alt-slowest-gray.svg"> {{ $t('menu-video-quality-low') }}</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <h6 class="dropdown-header">{{ $t('menu-title-video-advanced') }}</h6>
              <b-dropdown-item @click='shareScreen()' href="#"><img src="/static-appopensalud/img/icons/share-desktop-gray.svg"> {{ $t('menu-share-screen') }}</b-dropdown-item>
          </b-nav-item-dropdown >
          <b-nav-item-dropdown v-bind:text="$t('menu-language')" right>
            <b-dropdown-item @click='setLocale("es")' href="#"><img class="flag" src="/static-appopensalud/img/icons/flags/ES.svg" /> {{ $t('menu-language-es') }}</b-dropdown-item>
            <b-dropdown-item @click='setLocale("en")' href="#"><img class="flag" src="/static-appopensalud/img/icons/flags/GB.svg" /> {{ $t('menu-language-en') }}</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
    </b-navbar>  -->
    <main>
      <gtag-iframe/>
      <transition name="fade" mode="out-in" > 
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </main>
    </div>
  </div>
</template>

<script>
import GtagIframe from '@/components/utils/GtagIframe.vue'

export default {
  name: 'app',
  components: {
    'gtag-iframe': GtagIframe
  },
  data () {
    return {
      locale: 'es',
      sidebar: {
        show: false,
        video: false,
        audio: false
      }
    }
  },
  watch: {
    // locale (val) {
    //   this.$i18n.locale = val
    // }
  },
  methods: {
    setLocale: function (listlocale) {
      // this.locale = listlocale
      this.$i18n.locale = listlocale
    },
    showVideo () {
      this.sidebar.video = true
      document.getElementById('rightMenu').style.display = 'block'
    },
    hideVideo () {
      this.sidebar.video = false
    },
    setVideoQualityHigh () {
      this.$store.commit('setVideoQuality', 1)
    },
    setVideoQualityMedium () {
      this.$store.commit('setVideoQuality', 2)
    },
    setVideoQualityLow () {
      this.$store.commit('setVideoQuality', 3)
    },
    muteVideo () {
      this.$store.commit('disableVideo')
    },
    shareScreen () {
      this.$store.commit('toggleShareScreen')
    }
  },
	mounted () {
		/* window.addEventListener('orientationchange', this.$store.commit('setIsDesktop'))
		window.addEventListener('resize', this.$store.commit('setIsDesktop')) */
	}
}
</script>

<style>
@import "../static-appopensalud/css/general.css";
@import "../static-appopensalud/css/navbar.css";

.fade-enter-active, .fade-leave-active {
  transition: opacity .4s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.dropdown-item img {
  margin-right:10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue